export default "__VITE_ASSET__CFj0dRIL__"